import { useState, useContext } from "react";
import { useSelector } from "react-redux";

import { useFilter } from "@stadium/shared/src/hooks/use-filter";

import { BackIconButton, InternalButton } from "@sharedComponents/buttons";
import BottomIconHideWrapper from "@stadium/shared/src/components/bottom-icon-hide-wrapper";
import {
  DropdownToggle,
  ResponsiveDrawerDropdown,
} from "@stadium/ui/src/components/bootstrap-dropdown";
import { DropdownContext } from "@stadium/ui/src/components/bootstrap-dropdown/context";
import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import { LISTING_SECTION_REF } from "@components/store/products/listing";
import { selectAppliedFiltersCount } from "@stadium/redux-utils/selectors/filterSelector";

import FilterV2DesktopMultiselect from "./web";
import FilterV2DrawerContent from "./responsive";

import style from "../filterDropdown.module.scss";

const FilterV2Dropdown = ({ config }) => {
  const [currentOptionKey, setCurrentOptionKey] = useState(null);

  const { clear } = useFilter(config || []);

  const appliedFiltersCount = useSelector(selectAppliedFiltersCount);

  const label = appliedFiltersCount ? `Filters (${appliedFiltersCount})` : "Filters";

  const renderTitle = () => {
    if (!currentOptionKey) {
      return label;
    }
    const currentOption = (config || []).find((c) => c.id === currentOptionKey);
    return (
      <BackIconButton
        className={style.backIcon}
        onClick={(e) => {
          e.stopPropagation();
          setCurrentOptionKey(null);
        }}
      >
        <span className={style.backButtonLabel}>{currentOption?.label || label}</span>
      </BackIconButton>
    );
  };

  const { isMobileDevice, isTabletDevice } = useContext(CurrentDeviceContext);
  const showDrawer = isMobileDevice || isTabletDevice;

  const commonDropdownProps = {
    heading: (
      <DropdownToggle className={`${style.filterHeaderLabel} ${style.filterHeaderLabelV2}`}>
        {renderTitle()}
      </DropdownToggle>
    ),
    label: (
      <>
        <DropdownToggle
          className={`${style.filterCtaToggle} ${style.filterCtaToggleV2Responsive} dropdown-toggle ftDropdownToggle`}
          activeClassName={style.openDDClass}
          showDropdownIcon={false}
        >
          {label}
        </DropdownToggle>
        {!!appliedFiltersCount && (
          <InternalButton
            className={style.clearFiltersBtn}
            onClick={() => clear()}
            styleType="link"
          >
            Clear all
          </InternalButton>
        )}
      </>
    ),
    className: style.restrictionDropdown,
    menuClassName: style.dropdownMenu,
    onToggle: (isOpen) => {
      setCurrentOptionKey(null);
      if (LISTING_SECTION_REF?.current) {
        LISTING_SECTION_REF.current.style = isOpen ? "z-index:11" : "";
      }
    },
  };

  const drawerContent = (
    <DropdownContext.Consumer>
      {({ isDropdownOpen, setIsDropdownOpen }) =>
        isDropdownOpen && config?.length > 0 ? (
          <BottomIconHideWrapper>
            <FilterV2DrawerContent
              config={config}
              setIsDropdownOpen={setIsDropdownOpen}
              currentOptionKey={currentOptionKey}
              setCurrentOptionKey={setCurrentOptionKey}
            />
          </BottomIconHideWrapper>
        ) : null
      }
    </DropdownContext.Consumer>
  );

  if (showDrawer) {
    return (
      <ResponsiveDrawerDropdown {...commonDropdownProps} showBottomDrawerForTabletDevice>
        {drawerContent}
      </ResponsiveDrawerDropdown>
    );
  }

  return <FilterV2DesktopMultiselect config={config} />;
};

export default FilterV2Dropdown;
